export const audittrailListingConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETALLAUDITTRAILLISTING_REQUEST: 'GETALLAUDITTRAILLISTING_REQUEST',
    GETALLAUDITTRAILLISTING_REQUEST_END: 'GETALLAUDITTRAILLISTING_REQUEST_END',

    GETALLAUDITTRAILLISTING_SUCCESS: 'GETALLAUDITTRAILLISTING_SUCCESS',
    GETALLAUDITTRAILLISTING_FAILURE: 'GETALLAUDITTRAILLISTING_FAILURE'
};
